



































































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import ChildAccountsInjectorMixin from "@/mixins/childAccountsInjectorMixin";

// Enums/Data
import { ListDisplayMode } from "@/data/constants";

// Types
import { IImport } from "@/models/imports";
import Context from "@/mixins/context";

@Component({
  components: {
    "child-accounts-list-item": () =>
      import("@/components/app/global/client/childAccountsListItem.vue")
  }
})
export default class ChildAccountsListing extends Mixins(
  Context,
  ChildAccountsInjectorMixin
) {
  // Data

  public gridDisplayMode = ListDisplayMode.GRID;

  // Methods

  public getImportRoute(importId: IImport["id"]) {
    return {
      name: "adminImport",
      params: {
        importId
      }
    };
  }

  // Computed

  public get skeletonSize() {
    const { data } = this.$childAccountsData.table;
    if (data.length) return data.length;

    return this.$store.getters["ui/isMobile"] ? 2 : 5;
  }

  public get showEmptyState() {
    return (
      !this.$childAccountsData.isLoading &&
      !this.$childAccountsData.table.data.length
    );
  }

  public get showSkeletons() {
    return this.$childAccountsData.isLoading || !this.$childAccountsData.total;
  }
}
